import React from "react";

const CompanyHeader = ({ profile }) => {
  return (
    <React.Fragment>
      {profile && (
        <div>
          <h4>WELCOME TO
            <span style={{marginLeft: "0.5em"}}/>
            {profile.CompanyLogo ? (
              <img
                src={profile.CompanyLogo}
                alt={profile.CompanyName}
                height="50em"
              />
            ) : (
              <span>{profile.CompanyName}</span>
            )}
          </h4>
        </div>
      )}
    </React.Fragment>
  );
};

export default CompanyHeader;
